import React, { useState } from 'react';
import "../css/Dropdown.css";

const Dropdown = ({ defaultValue, options, onChange }) => {

    const [selected, setSelected] = useState(defaultValue);

    const updateSelected = (event) => {
        setSelected(event.target.value);
        onChange(event.target.value);
    }

    return (
        <div className="dd-container">
            <label htmlFor="dropdown">Order List by: </label>
            <select id="dropdown" onChange={updateSelected} value={selected}>
                {options && options.map(op => {
                    return (
                        <option key={op} value={op}>{op}</option>
                    )
                })}
            </select>
        </div>
    );
}

export default Dropdown;